import React, { useEffect, useMemo, useRef, useState } from "react";
import {
	Button,
	Col,
	Form,
	Modal,
	Overlay,
	Popover,
	Row,
} from "react-bootstrap";
import ReactSelect from "react-select";
import Flatpickr from "react-flatpickr";
import { useDispatch, useSelector } from "react-redux";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import {
	fetchAllOrgsData,
	selectAllOrgs,
} from "../../redux/actions/getAllOrgsAction";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import moment from "moment";
import { fetchOrgRegdInsData } from "../../redux/actions/getRegdInsAction";

const AddAward = ({ getUserCv, showAward, handleCloseAward, userDataId }) => {
	const dispatch = useDispatch();

	const sessionId = localStorage.getItem("sessionId");
	const userType = localStorage.getItem("userType");
	const { CandidateId } = useParams();

	const [isPresent, setIsPresent] = useState(false);
	const [description, setDescription] = useState("");
	const [awardname, setAwardname] = useState("");
	const [recognition, setRecognition] = useState("");
	const [isuseDate, setIsUseDate] = useState("");
	const [OrgName, setOrgName] = useState("");
	const [display, setDisplay] = useState(false);
	const [InsName, setInsName] = useState("");

	const [formChanged, setFormChanged] = useState(false); // Track if form is modified
	const [isSubmitting, setIsSubmitting] = useState(false);
	// Handle changes and mark form as modified
	const handleFieldChange = (setter, value, fieldName) => {
		setter(value);

		// Ensure values are strings (avoid .trim() errors)
		const updatedAwardName = fieldName === "awardname" ? String(value || "") : String(awardname || "");
		const updatedOrgType = fieldName === "orgType" ? String(value || "") : String(orgType || "");
		const updatedRecognition = fieldName === "recognition" ? String(value || "") : String(recognition || "");
		// const updatedCitySearch = fieldName === "citySearch" ? String(value || "") : String(citySearch || "");
		const updatedIssueDate = fieldName === "issueDate" ? String(value || "") : String(isuseDate || "");

		// Check if all required fields are filled
		const allFieldsFilled =
			updatedAwardName.trim() !== "" &&
			updatedOrgType.trim() !== "" &&
			updatedRecognition.trim() !== "" &&
			// updatedCitySearch.trim() !== "" &&
			updatedIssueDate.trim() !== ""; // Add other required fields if needed

		setFormChanged(allFieldsFilled);
	};



	const handleSubmit = async (e) => {
		e.preventDefault();
		setDisplay(true);
		setIsSubmitting(true); // Disable the button during submission

		const body = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: userType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			//orgID: getallorgsId === "" ? neworgId : getallorgsId,
			orgID: getallorgsId === '' || getallorgsId === 0 ? neworgId : getallorgsId,
			issuerOrgType: regdType
				? (regdType === 1 ? 1 : regdType === 2 ? 2 : regdType === 3 ? 3 : regdType === 4 ? 4 : regdType === 5 ? 5
					: null)
				: 5,
			name: awardname,
			recognition: recognition,
			issueDate: moment(isuseDate).format("YYYY-MM-DD"),
			description: description,
			cityId: citySearch ? citySearch : null,
		};
		console.log("body", body);

		if (
			awardname === "" ||
			recognition === "" ||
			isuseDate === "" ||
			// citySearch === "" ||
			orgType === ""
		) {
			toast.error("Please fill all the required fields");
			setIsSubmitting(false); // Re-enable the button if validation fails
		} else {
			try {
				const res = await axios.post("/Resume/AddAward", body);
				// console.log("res=====>", res);

				toast.success(res.data.message);
				resetForm();
			} catch (error) {
				if (error.response && error.response.status === 404) {
					toast.error(error.response.data.message);
				} else {
					toast.error(error.response?.data?.title);
				}
			} finally {
				setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
			}
		}
	};

	const resetForm = () => {
		handleCloseAward();
		getUserCv();
		setAwardname("");
		setOrgType("");
		setRecognition("");
		setCitySearch("");
		setInsName("")
		setIsUseDate(null);
		setGetAllOrgsId(null)
		setDescription("");
		setFormChanged(false); // Disable the button after update
	};

	const handleCloseAwardFn = () => {
		resetForm(); // Call resetForm when closing the modal
		handleCloseAward();
	};

	// Create New award

	const [showCreateAward, setShowCreateAward] = useState(false);
	const handleOpenCreateAward = () => setShowCreateAward(true);
	const handleCloseCreateAward = () => setShowCreateAward(false);

	// ...............................Get organization DDL.......................................

	const [getallorgsId, setGetAllOrgsId] = useState("");
	const [regdType, setRegdType] = useState("");

	const [orgType, setOrgType] = useState("");
	const { getallorgsList, selectedgetallId } = useSelector(
		(state) => state.getallorgs
	);
	console.log("org Option==>", getallorgsList)
	const reversedOrgList = useMemo(() => {
		return [...getallorgsList].reverse(); // Create a new reversed copy
	}, [getallorgsList]);

	useEffect(() => {
		dispatch(fetchAllOrgsData());

	}, [dispatch]);

	const handleOrganization = (selectedOption) => {
		console.log("Selected Option==>", selectedOption)
		if (selectedOption) {
			setGetAllOrgsId(selectedOption.value);
			setOrgType(selectedOption.label);
			setRegdType(selectedOption.tagId);
		} else {
			setGetAllOrgsId(null);
			setRegdType(null)
		}
	};

	// ...............................City DDL.......................................


	const [neworgType, setneworgType] = useState("");
	const [neworgId, setneworgId] = useState("");

	const [orgCity, setOrgCity] = useState(null);
	const [citySearch, setCitySearch] = useState("");
	const [searchTerm, setSearchTerm] = useState("")
	const [cityNameOption, setCityNameOption] = useState([])

	const getCityList = async (pageNumber = 1, pageSize = 10) => {
		try {
			const response = await axios.post(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`, {
				pageNumber,
				pageSize
			})
			console.log("Get City Name List==>", response)
			const cityList = response.data.responseData.citiesDDL.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setCityNameOption(cityList)
		}
		catch (error) {
			//toast.error(error.message || 'Something went wrong while fetching city data',)
		}
	}

	useEffect(() => {
		getCityList();
	}, [searchTerm]);


	const handleCitySelect = (selectedOption) => {
		setCitySearch(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm("");
		setCityNameOption([]);
	};
	const handleCitySelectOrg = (selectedOption) => {
		setOrgCity(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm("");
		setCityNameOption([]);
	};

	const [OrganizationName, setOrganizationName] = useState("");
	const [getOrgInsTId, setGenOrgInstId] = useState(null);

	const handleSaveInstitution = async () => {
		// setDisplay(true);
		const formData = new FormData();
		formData.append("orgName", OrganizationName);
		formData.append("OrgType", "UnRegdGeneralOrg");
		formData.append("CityID", orgCity);
		formData.append("OrgLogo", fileName);
		formData.append("sessionId", sessionId);
		console.log("formData", formData);

		try {
			const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			console.log("res", res);
			// setneworgType(res.data.responseData.value);
			setneworgId(res.data.responseData.id);
			toast.success(`${res.data.message} The newly created Organization is now available at the top of the dropdown. Please select it.`);
			setOrgCity("");
			setOrgName("")
			dispatch(fetchAllOrgsData());

		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message || "An error occurred");
			}
		}
	};


	// ...................file selecting...............

	const [fileName, setFileName] = useState(""); // State to store selected filename
	const handleFileChange = (event) => {
		const file = event.target.files[0]; // Get the selected file
		if (file) {
			setFileName(file.name); // Set the filename in state
		}
	};

	// ...................toolTip...............
	const [showTooltip, setShowTooltip] = useState(false);
	const targetRef = useRef(null);

	const toggleTooltip = () => {
		console.log("Toggling Tooltip");
		setShowTooltip((prev) => !prev);
	};

	return (
		<>
			<Modal show={showAward} onHide={handleCloseAwardFn} centered size="lg">
				<Modal.Header>
					<Modal.Title>Add award</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseAwardFn} />
				</Modal.Header>
				<Modal.Body className="settings">
					<Row>
						<Col md={6} className="mb-2">
							<Form.Group controlId="Awards">
								<Form.Label className="class-type">
									Award name{" "}
									<span style={{ color: "red" }}> *</span>
								</Form.Label>
								<Form.Control
									type="text"
									className="Dark-Input-from-group"
									value={awardname}
									// onChange={(e) => setAwardname(e.target.value)}
									// onChange={(e) => handleFieldChange(setAwardname, e.target.value)} // Track changes
									onChange={(e) => handleFieldChange(setAwardname, e.target.value, "awardname")}
									placeholder="Enter award name"
								/>
								{/* {display && !awardname ? (
                  <span className="error_msg_lbl">Add Award Name </span>
                ) : null} */}
							</Form.Group>
						</Col>

						{/* Organization */}
						<Col md={6} className="mb-2">

							<Form.Group controlId="addorganization">
								<Form.Group controlId="organization">
									<Form.Label className="class-type">
										Organization
										<span style={{ color: "red" }}> *</span>
									</Form.Label>
									{OrgName !== "" ? (
										<div>
											<input
												type="text"
												value={OrgName}
												placeholder="Enter org name"
												className="mb-2 form-control Dark-Input-from-group"
												disabled
											/>
										</div>
									) : (
										<div className="post-form-group">
											<ReactSelect
												options={reversedOrgList}
												// onChange={handleOrganization}
												onChange={(selectedOption) => handleFieldChange(handleOrganization, selectedOption)} // Track changes
												// onChange={(option) => {
												//   handleFieldChange(setGetAllOrgsId, option ? option.value : ""); // Track changes
												//   setOrgType(option ? option.tagId : ""); // Set organization type
												// }}
												value={
													reversedOrgList.find((
														(option) => {
															if (InsName !== "" && InsName !== null) {
																return option.value === InsName;
															} else {
																return option.value === getallorgsList && option.tagId === regdType
															}
														}
													))
												}
												// value={
												// 	getallorgsList.find(
												// 		(option) => option.value === getallorgsId && option.tagId === regdType
												// 	) || null
												// }
												getOptionValue={(option) => `${option.value}-${option.tagId}`}

												formatOptionLabel={(option) => (
													<div style={{ fontWeight: option.tagId === 1 || option.tagId === 2 ? "bold" : "normal" }}>
														{option.label} <span>({option.tagId === 1 ? "Insitution" : option.tagId === 2 ? "Company" : option.tagId === 3 ? "UnredgCompany" : option.tagId === 4 ? "UnredgInstitution" : option.tagId === 5 ? "UnRegdGeneralOrg" : ""})</span>
													</div>
												)}
												placeholder="Select organization"
												classNamePrefix="react-select"
												className="form-control Dark-Input-from-group"
												styles={customStyles}
												isClearable
											/>
										</div>
									)}
								</Form.Group>
								<a
									href="#"
									ref={targetRef}
									onClick={(e) => {
										e.preventDefault();
										toggleTooltip();
									}}
									className="createModal"
								// isDisabled={!selectedIndustryId} // Disable until industry is selected
								>
									Create new
								</a>
								<Overlay
									target={targetRef.current}
									show={showTooltip}
									placement="right"
									rootClose
									container={document.querySelector(".modal")}
									onHide={() => setShowTooltip(false)} // Close when clicking outside
								>
									<Popover id="popover-basic" className="overlay-popover-modal">
										<Popover.Header as="h3" className="Dark-Body-Card-group">Create organization</Popover.Header>
										<Popover.Body className="Dark-Body-Card-group">
											<Form>
												<div>
													<label className="mb-1 Text-mb-Create">Org name</label>
													<input
														type="text"
														value={OrganizationName}
														onChange={(e) => {
															setOrganizationName(e.target.value)
															setOrgName(e.target.value);
															setGetAllOrgsId(e.target.value);
															handleFieldChange(setGetAllOrgsId, e.target.value, "getallorgsId")

														}}
														placeholder="Enter org name"
														className="mb-2 form-control Dark-Input-from-group"
													/>
												</div>

												<div>
													<label className="mb-1 Text-mb-Create">City</label>
													<ReactSelect
														options={cityNameOption}
														onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
														onChange={handleCitySelectOrg} // Select hone ke baad clear ho jaye
														placeholder="Search & select city"
														classNamePrefix="react-select"
														className="form-control Dark-Input-from-group"
														styles={customStyles}
														isClearable
													/>
												</div>
												<div className=" mt-2 mb-2 Text-mb-Create">
													<label className="mb-1">Org logo</label>
													<input
														type="file"
														id="lastName"
														className="form-control Dark-Body-Card-group"
														placeholder=""
														onChange={handleFileChange}

													/>

												</div>
												<div className="d-flex justify-content-end">
													<Button
														variant="primary"
														size="sm"
														onClick={() => {
															handleSaveInstitution()
															setShowTooltip(false)
														}
														}

														className="me-2"
													>
														Save
													</Button>
													<Button
														variant="secondary"
														size="sm"
														onClick={() => setShowTooltip(false)}
													>
														Cancel
													</Button>
												</div>
											</Form>
										</Popover.Body>
									</Popover>
								</Overlay>
							</Form.Group>
						</Col>

						{/* Recognition */}
						<Col md={6} className="mb-2">
							<Form.Group controlId="recognition">
								<Form.Label className="class-type">
									{" "}
									Recognition{" "}
									<span style={{ color: "red" }}> *</span>
								</Form.Label>
								<Form.Control
									type="text"
									className="Dark-Input-from-group"
									value={recognition}
									// onChange={(e) => setRecognition(e.target.value)}
									// onChange={(e) => handleFieldChange(setRecognition, e.target.value)} // Track changes
									onChange={(e) => handleFieldChange(setRecognition, e.target.value, "recognition")}
									placeholder="Enter recognition"
								/>
								{/* {display && ! recognition ? (
                  <span className="error_msg_lbl">Enter Recognition </span>
                ) : null} */}
							</Form.Group>
						</Col>

						{/* City */}
						<Col md={6} className="mb-2">
							<Form.Group controlId="city">
								<Form.Label className="class-type">
									City
									{/* <span style={{ color: "red" }}> *</span> */}
								</Form.Label>
								<div className="post-form-group mb-0">
									<ReactSelect
										options={cityNameOption}
										onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
										// onChange={handleCitySelect} // Select hone ke baad clear ho jaye
										// onChange={(option) => handleFieldChange(setCitySearch, option ? option.value : "", "citySearch")}
										onChange={(option) => setCitySearch(option ? option.value : "", "citySearch")}
										placeholder="Search & select city"
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										styles={customStyles}
										isClearable
									/>
								</div>
								{/* {display && !citySearch ? (
                  <span className="error_msg_lbl">Add City</span>
                ) : null} */}
							</Form.Group>
						</Col>

						{/* Issue Date */}
						<Col md={6} className="mb-2">
							<Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
								<Form.Label className="class-type col-md-12">
									Issue date<span className="text-danger"> *</span>
								</Form.Label>
								<Flatpickr
									type="number"
									id="issueDate"
									value={isuseDate}
									className="Dark-Input-from-group"
									// onChange={(date) => setIsUseDate(date[0])}
									// onChange={(date) => handleFieldChange(setIsUseDate, (date[0]))} // Track changes
									onChange={(date) => handleFieldChange(setIsUseDate, date[0], "issueDate")}
									placeholder="Select issue date"
									options={{
										maxDate: new Date(), // Disable future dates  
										static: true, // Keeps the calendar visible on click         
									}}
								/>
								{/* {display && !isuseDate ? (
                  <span className="error_msg_lbl">Add Date</span>
                ) : null} */}
							</Form.Group>
						</Col>
					</Row>

					<Row>
						<Col md={12} className="mb-2">
							<Form.Group controlId="description">
								<Form.Label className="class-type">Description</Form.Label>
								<Form.Control
									as="textarea"
									id="about"
									className="Dark-Input-from-group"
									rows={3}
									value={description}
									// onChange={(e) => setDescription(e.target.value)}
									onChange={(e) => handleFieldChange(setDescription, e.target.value)} // Track changes
									placeholder="Enter description"
								/>
								{/* {display && !description ? (
                  <span className="error_msg_lbl">Add Description </span>
                ) : null} */}
							</Form.Group>
						</Col>
					</Row>
					{/* Submit and Close Buttons */}
					<div className="add-class-submit-button mt-4 d-flex justify-content-center">
						<div className="khojPrimaryBtn ms-3"
							onClick={handleSubmit}
							style={{ cursor: formChanged ? "pointer" : "default" }}
						>
							<a
								href="#/"
								// onClick={handleSubmit}
								className={`btn ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
								disabled={!formChanged || isSubmitting}
								style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
							>

								Submit
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>

			<Modal
				show={showCreateAward}
				onHide={handleCloseCreateAward}
				centered
				size="md"
			>
				<Modal.Header closeButton>
					<Modal.Title>Create award</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={12}>
							<div className="post-form-group mb-1">
								<label htmlFor="certificateName">
									Award name{" "}
									<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<input type="text" placeholder="Enter Award name" />
							</div>
						</Col>
					</Row>

					{/* Submit and Close Buttons */}
					<div className="add-class-submit-button mt-4 d-flex justify-content-center">
						<div className="khojPrimaryBtn ms-3">
							<a href="#/" className="" onClick={handleSubmit}>
								Save
							</a>
						</div>
						<div className="khojPrimaryBtn ms-3">
							<a href="#/" className="">
								Close
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default AddAward;
